import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

import paymentsReducer from '../reducers/paymentsReducer'
import PaymentListContainer from '../containers/PaymentListContainer'
import PaymentFormContainer from '../containers/PaymentFormContainer'

const store = createStore(
  paymentsReducer,
  applyMiddleware(thunk)
)

export default class Payments extends Component {
  render() {
    return (
      <Provider store={store}>
        <div>
          {/*<PaymentFormContainer {...this.props} />*/}
          <PaymentListContainer {...this.props} />
        </div>
      </Provider>
    )
  }
}
